var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",class:{ opened: _vm.openedMenu },on:{"click":function($event){return _vm.$emit('click')}}},[_c('links')],1)}
var staticRenderFns = []

export { render, staticRenderFns }